export function StatCard({ label, value, icon: Icon, accent = "text-primary", sub, testid }) {
  return (
    <div
      className="bg-card rounded-xl border border-border p-5 shadow-sm hover:shadow-md transition-shadow animate-rise"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
        {Icon && <Icon className={`h-5 w-5 ${accent}`} />}
      </div>
      <p className="text-3xl font-bold text-foreground mt-3">{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}
